export class BentoExpandable extends HTMLElement {
  constructor() {
    super();
    this._refs = {
      el: this,
      container: this.querySelector('.bento-expandable__grid'),
      items: this.querySelectorAll('.bento-expandable__item'),
      paddingBlock: 40,
      isPreview: this.hasAttribute('data-preview'),
      origRect: {
        containerHeight: 0,
        left: 0,
        top: 0,
        width: 0,
        height: 0,
      },
    };
    if (!this._refs.isPreview) {
      this._init();
    }
  }
  _init() {
    for (let item of Array.from(this._refs.items)) {
      const cta = item.querySelector('.bento-expandable__cta');
      item.addEventListener('click', () => {
        const wrapper = item.querySelector('.bento-expandable__wrapper');
        if (item.classList.contains('bento-expandable__item--expanded')) {
          this._closeItem(item, wrapper);
          return;
        }
        // Capture original rect (force layout read)
        item.offsetHeight; // Force reflow
        const containerRect = this._refs.container.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        this._refs.origRect = {
          containerHeight: containerRect.height,
          left: itemRect.left - containerRect.left,
          top: itemRect.top - containerRect.top,
          width: itemRect.width,
          height: itemRect.height,
        };

        // Apply expanded class after brief delay for accurate start state
        this._expandItem(item, wrapper);
      });
      cta.addEventListener('click', (e) => {
        e.stopPropagation();
        item.click();
      });
    }
  }
  get animationSettings() {
    return {
      duration: 400,
      easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      pseudoElement: null,
    };
  }
  get animateIn() {
    return [
      {
        position: 'absolute',
        left: this._refs.origRect.left + 'px',
        top: this._refs.origRect.top + 'px',
        width: this._refs.origRect.width + 'px',
        height: this._refs.origRect.height + 'px',
        zIndex: 1,
      },
      {
        position: 'absolute',
        inset: '0px',
        width: '100%',
        height: '100%',
        zIndex: 10,
      },
    ];
  }
  get animateOut() {
    return this.animateIn.reverse();
  }
  _addGridMinHeight(wrapper) {
    const content = wrapper.querySelector('.bento-expandable__content');
    const containerPadding = this._refs.paddingBlock * 2;
    const contentHeight = this._getHeightAtFullWidth(content);

    if (this._refs.origRect.containerHeight < contentHeight + containerPadding) {
      this._refs.container.style.minHeight = `${contentHeight + containerPadding}px`;
    }
  }
  _removeGridMinHeight() {
    this._refs.container.removeAttribute('style');
  }
  _expandItem(item, wrapper) {
    item.classList.remove('bento-expandable__item--default');
    wrapper.classList.add('bento-expandable__wrapper--animate');
    this._addGridMinHeight(wrapper);

    // Animate to expanded
    wrapper.animate(this.animateIn, this.animationSettings).onfinish = () => {
      item.classList.add('bento-expandable__item--expanded');
      wrapper.classList.remove('bento-expandable__wrapper--animate');
    };
  }
  _closeItem(item, wrapper) {
    wrapper.classList.add('bento-expandable__wrapper--animate');

    wrapper.animate(this.animateOut, this.animationSettings).onfinish = () => {
      item.classList.remove('bento-expandable__item--expanded');
      item.classList.add('bento-expandable__item--default');
      wrapper.classList.remove('bento-expandable__wrapper--animate');
      this._removeGridMinHeight();
    };
  }
  _getHeightAtFullWidth(originalEl) {
    // Deep clone
    const cloneContainer = document.createElement('div');
    const clone = originalEl.cloneNode(true);

    // Copy computed styles by iterating properties (safe way)
    const computedStyle = getComputedStyle(originalEl);
    for (let i = 0; i < computedStyle.length; i++) {
      const propName = computedStyle[i];
      clone.style.setProperty(
        propName,
        computedStyle.getPropertyValue(propName),
        computedStyle.getPropertyPriority(propName),
      );
    }

    cloneContainer.style.cssText += `
            padding-block: ${40}px;
            padding-inline: ${40}px;
        `;
    clone.style.cssText += `
            width: calc(100% - 50px) !important;
            position: relative !important;
            visibility: hidden !important;
            height: auto !important;
            opacity: 0 !important;
            pointer-events: none !important;
            transform: unset !important;
            z-index: -1 !important;
        `;

    // Append, measure, remove
    cloneContainer.appendChild(clone);
    this._refs.el.appendChild(cloneContainer);
    clone.offsetHeight;
    const fullHeight = clone.offsetHeight;
    cloneContainer.remove();

    return fullHeight;
  }
}
